import { Observable } from 'rxjs';
import { API } from 'aws-amplify';
import { ConfigService } from '../../config';
import { normalizeAugerPurgeError } from './auger-purge.util';
import * as i0 from "@angular/core";
import * as i1 from "../../config/config.service";
var AugerPurgeHttpService = /** @class */ (function () {
    function AugerPurgeHttpService(configService) {
        this.configService = configService;
        this.apiName = this.configService.get('host');
    }
    AugerPurgeHttpService.prototype.getConfig = function (machineId) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/auger-purge/config/' + encodeURIComponent(machineId);
            API.get(_this.apiName, path, { response: false }).then(function (response) {
                observer.next(response.data);
                observer.complete();
            }).catch(function (error) {
                observer.error(normalizeAugerPurgeError(error));
            });
        });
    };
    AugerPurgeHttpService.prototype.setConfig = function (patch) {
        var _this = this;
        return new Observable(function (observer) {
            API.patch(_this.apiName, '/dashboard/auger-purge/config', { body: patch }).then(function (response) {
                observer.next(response.data);
                observer.complete();
            }).catch(function (error) {
                observer.error(normalizeAugerPurgeError(error));
            });
        });
    };
    AugerPurgeHttpService.prototype.getCommand = function (commandId) {
        var _this = this;
        return new Observable(function (observer) {
            var path = '/dashboard/auger-purge/commands/' + encodeURIComponent(commandId);
            API.get(_this.apiName, path, { response: false }).then(function (response) {
                observer.next(response.data);
                observer.complete();
            }).catch(function (error) {
                observer.error(normalizeAugerPurgeError(error));
            });
        });
    };
    AugerPurgeHttpService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function AugerPurgeHttpService_Factory() { return new AugerPurgeHttpService(i0.ɵɵinject(i1.ConfigService)); }, token: AugerPurgeHttpService, providedIn: "root" });
    return AugerPurgeHttpService;
}());
export { AugerPurgeHttpService };
